import { ruleRunner } from 'validations/ruleRunner';
import { ruleIfInArray, required, minimun, ruleIf, ruleIfEqualsAND } from 'validations/rules';

const Validations = [
  ruleRunner('comission_value', 'porcentagem', ruleIfInArray('charge_type', ['N'], minimun(0.01))),
  ruleRunner('comission_type', ruleIfInArray('charge_type', ['N'], required)),

  ruleRunner('membership_comission_value', 'porcentagem', ruleIfInArray('charge_type', ['A'], ruleIf('membership_fee', minimun(0.01)))),
  ruleRunner('membership_comission_type', ruleIfInArray('charge_type', ['A'], required)),
  ruleRunner(
    'membership_comission_value',
    'porcentagem',
    ruleIfEqualsAND(
      [
        { field: 'membership_fee', value: true },
        { field: 'charge_type', value: 'A' },
      ],
      minimun(0.01)
    )
  ),
  ruleRunner(
    'recurring_comission_value',
    'comissão',
    ruleIfEqualsAND(
      [
        { field: 'has_children', value: false },
        { field: 'charge_type', value: 'A' },
      ],
      minimun(1)
    )
  ),
  ruleRunner('recurring_comission_value', ruleIfInArray('charge_type', ['A'], required)),

  ruleRunner('recruit_commission_value', 'porcentagem', ruleIf('recruit', minimun(0.01))),
  ruleRunner('recruit_commission_type', ruleIf('recruit', required)),
];

export default Validations;
